import { render } from "./NavigationModal.vue?vue&type=template&id=658b2632&scoped=true&ts=true"
import script from "./NavigationModal.vue?vue&type=script&lang=ts"
export * from "./NavigationModal.vue?vue&type=script&lang=ts"

import "./NavigationModal.vue?vue&type=style&index=0&id=658b2632&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658b2632"]])

export default __exports__